export default __webpack_public_path__ + "static/2-64ff402141874b34a521f19d1fe93ff6.jpeg";